import React from 'react'
import PropTypes from 'prop-types'
import withType from 'components/common/hoc/withType'
import isEmpty from 'lodash/isEmpty'
import { compose } from 'recompose'
import { BOT_VEHICLE_SELECTOR_ID, BOT_VEHICLE_SELECTOR_PLACEHOLDER_ID, PAGE_HEADER_CHANGED } from 'constant'
import Portal from 'components/common/Portal/Portal'
import Placeholder from 'components/common/Placeholder'
import toggle from 'components/common/hoc/toggle'
import VehicleSelector from './VehicleSelector'
import withActiveVehicle from 'components/common/hoc/withActiveVehicle'
import withIsRegionPage from 'components/common/hoc/withIsRegionPage'

const WrappedVehicleSelector = props => {
  const { isRegionPage, activeVehicle: { vehicleName }} = props
  const showVehicleSelectorHeader = !isRegionPage || !isEmpty(vehicleName)

  return <React.Fragment>
    {showVehicleSelectorHeader && (
      <Portal id={ BOT_VEHICLE_SELECTOR_ID }>
        <VehicleSelector { ...props } />
      </Portal>
    )}

    <Portal id={ BOT_VEHICLE_SELECTOR_PLACEHOLDER_ID }>
      {
        props.mainVehicleSelectorBlock[0]['@type'] === 'ActiveVehicle' ?
          <React.Fragment>
            {/* non empty car bar */}
            {/* desktop */}<Placeholder height="101px" alternative="280px" condition={ props.expanded } desktopOnly />
            {/* mobile */}<Placeholder height="58px" alternative="363px" condition={ props.expanded } mobileOnly />
          </React.Fragment> :
          <React.Fragment>
            {/* empty car bar */}
            {/* desktop */}<Placeholder height="76px" alternative="227px" condition={ props.expanded } desktopOnly />
            {/* mobile */}<Placeholder height="61px" alternative="350px" condition={ props.expanded } mobileOnly />
          </React.Fragment>
      }
    </Portal>
  </React.Fragment>
}

WrappedVehicleSelector.propTypes = {
  activeVehicle: PropTypes.shape(),
  expanded: PropTypes.bool,
  isRegionPage: PropTypes.bool,
  mainVehicleSelectorBlock: PropTypes.arrayOf(PropTypes.shape({
    '@type': PropTypes.string
  }))
}

const ConnectedVehicleSelector = toggle(WrappedVehicleSelector, false, PAGE_HEADER_CHANGED)

export default compose(
  withType({ type: 'VehicleSelector', placeholders: ['mainVehicleSelectorBlock', 'extendedVehicleSelectorBlock']}),
  withActiveVehicle,
  withIsRegionPage
)(ConnectedVehicleSelector)
